/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Ask_EyebrowInputs */

const en_us2_search_ask_eyebrow = /** @type {(inputs: Search_Ask_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask your trainer`)
};

const pt_br2_search_ask_eyebrow = /** @type {(inputs: Search_Ask_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao personal`)
};

const es_419_search_ask_eyebrow = /** @type {(inputs: Search_Ask_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregúntale a tu entrenador`)
};

const pt_pt2_search_ask_eyebrow = /** @type {(inputs: Search_Ask_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao treinador`)
};

const fr_fr2_search_ask_eyebrow = /** @type {(inputs: Search_Ask_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander à ton coach`)
};

const de_de2_search_ask_eyebrow = /** @type {(inputs: Search_Ask_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frag deinen Coach`)
};

const it_it2_search_ask_eyebrow = /** @type {(inputs: Search_Ask_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi al tuo coach`)
};

/**
* | output |
* | --- |
* | "Ask your trainer" |
*
* @param {Search_Ask_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_ask_eyebrow = /** @type {((inputs?: Search_Ask_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Ask_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_ask_eyebrow(inputs)
	if (locale === "es-419") return es_419_search_ask_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_search_ask_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_search_ask_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_search_ask_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_search_ask_eyebrow(inputs)
	return en_us2_search_ask_eyebrow(inputs)
});
export { search_ask_eyebrow as "search.ask_eyebrow" }